import { faAnglesLeft, faBars } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MatterService from '../../../../AppSettings/services/MatterService';
import UnifiedTopBar from '@frontend/Components/TopBar/UnifiedTopBar';
import { createDetailViewTemplate } from '@frontend/Components/TopBar/templates';
import { detailRouteBase, detailRoutePrefix } from '../../../utils/detailRoute';
import { isLegalEnvironment } from '@frontend/AppSettings/environmentConfig';

const AdNotesTopBar: React.FC = () => {
  const { matterId } = useParams();
  const navigate = useNavigate();
  const [matterName, setMatterName] = useState<{ mattername: string; sept_tenantid: string; } | null>(null);

  const fetchMatterName = useCallback(async () => {
    const response = await MatterService.getMatterName(matterId!);
    setMatterName(response ?? null);
  }, [matterId]);

  useEffect(() => {
    fetchMatterName();
  }, [fetchMatterName]);

  const matterTitle = matterName?.mattername
    ? `${matterId} - ${matterName?.mattername}`
    : 'Loading...';

  const dropdownItems = [
    { label: 'General', onClick: () => navigate(`${detailRouteBase()}/${matterId}`) },
    { label: 'Tasks', onClick: () => navigate(`${detailRouteBase()}/${matterId}/tasks`) },
    // Legal only: `/matterDetails/:matterId/financial/*` is registered inside App.js's
    // isLegalEnvironment block and has no engineering counterpart — engineering money lives on
    // the pipeline Commercial tab and /financials/*. detailRouteBase() resolves to
    // /projectDetails there, and with no catch-all route the tab rendered a blank page. The
    // retired project top bars carried four items and no Financial; the consolidation onto
    // these shared components is what surfaced it in the wrong vertical.
    ...(isLegalEnvironment
      ? [{ label: 'Financial', onClick: () => navigate(`${detailRouteBase()}/${matterId}/financial`) }]
      : []),
    { label: 'Files', onClick: () => navigate(`${detailRouteBase()}/${matterId}/files`) },
    { label: 'Notes', onClick: () => navigate(`${detailRouteBase()}/${matterId}/additionalNotes`) },
  ];

  const unifiedConfig = createDetailViewTemplate({
    leftExtras: [
      {
        type: 'button',
        icon: faAnglesLeft,
        onClick: () => navigate(`${detailRouteBase()}/${matterId}`),
        ariaLabel: 'Back to matter details',
      },
      {
        type: 'text',
        text: matterTitle,
        style: { marginLeft: '10px', fontWeight: 'bold' },
      },
    ],
    dropdown: {
      icon: faBars,
      ariaLabel: 'Matter sections',
      items: dropdownItems,
    },
    pageContext: {
      route: `${detailRoutePrefix()}-additional-notes`,
      matterId,
      matterName: matterName?.mattername,
    },
  });

  return <UnifiedTopBar {...unifiedConfig} />;
};

export default AdNotesTopBar;
